<template>
<div>
  <table class="table">
    <tr>
      <th>
        Nazwa
      </th>
      <th>
        Dane konta
      </th>
      <th>
        Akcje
      </th>
    </tr>
    <tr v-for="item in items">
      <td>
        <a class="main-link" @click="$router.push({name: 'admin.accounts.show', params: {id: item.id}})">{{ item.name }}</a>
      </td>
      <td>
        <p>
          {{ item.from_name }}<br />
        &lt;{{ item.from_address}}&gt;
        </p>
        <p>
          Host: <strong>{{ item.host }}</strong><br />
          Port: <strong>{{ item.port }}</strong><br />
          Nazwa użytkownika: <strong>{{ item.username }}</strong>
        </p>
      </td>
      <td class="actions">
        <ui-button type="flat" icon="mode_edit" color="primary" @click.prevent="$router.push({name: 'admin.accounts.edit', params: {id: item.id}})">Edytuj</ui-button>
        <ui-button type="flat" icon="highlight_off" color="danger" @click.prevent="remove(item)">Usuń</ui-button>
      </td>
    </tr>
  </table>
  <basic-pagination :meta="meta" @pagination-page="changePage" @pagination-limit="changeLimit"></basic-pagination>
</div>

</template>
<script>
import Accounts from './../../services/Accounts'
import EventEmitter from './../../services/EventEmitter'
import Loading from './../../mixins/Loading'
import Paginate from './../../mixins/Paginate'
import Notify from './../../mixins/Notify'

export default {
  mixins: [Loading, Paginate, Notify],
  methods: {
    getService () {
      return Accounts
    },
    _remove (item) {
      Accounts.remove(item.id).then((res) => {
        if (res.status === 204) {
          this.reload()
          this.notify('Usunięto')
        }
      })
    },
    remove (item) {
      EventEmitter.$emit('confirm.show', {
        confirmCb: () => {
          this._remove(item)
        }
      })
    }
  },
  mounted () {
    EventEmitter.$on('accounts.reload', () => {
      this.meta.current_page = 1
      this.reload()
    })
  }
  // events: {
  //   'accounts.reload': function () {
  //     this.meta.current_page = 1
  //     this.reload()
  //   }
  // }
}

</script>


// WEBPACK FOOTER //
// List.vue?0a4f5d2a